import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import statisticsApi from '../../api/statisticsApi';
import { message } from 'antd';

// 初始状态
const initialState = {
  // 平台概览数据
  platformOverview: {
    data: null,
    loading: false,
    error: null
  },
  // 每日统计数据
  dailyStatistics: {
    data: null,
    loading: false,
    error: null
  },
  // 按时间段统计数据
  periodStatistics: {
    data: null,
    loading: false,
    error: null
  },
  // 最近交易记录
  recentTransactions: {
    data: {
      records: [],
      total: 0,
      size: 10,
      current: 1
    },
    loading: false,
    error: null
  }
};

// 异步Action: 获取平台概览数据
export const fetchPlatformOverview = createAsyncThunk(
  'statistics/fetchPlatformOverview',
  async ({ timeRange, startDate, endDate, year, month }, { rejectWithValue }) => {
    try {
      const response = await statisticsApi.getPlatformOverview(timeRange, startDate, endDate, year, month);
      return response.data;
    } catch (error) {
      message.error(error.message || '获取平台概览数据失败');
      return rejectWithValue(error.message || '获取平台概览数据失败');
    }
  }
);

// 异步Action: 获取每日统计数据
export const fetchDailyStatistics = createAsyncThunk(
  'statistics/fetchDailyStatistics',
  async ({ startDate, endDate }, { rejectWithValue }) => {
    try {
      const response = await statisticsApi.getDailyStatistics(startDate, endDate);
      return response.data;
    } catch (error) {
      message.error(error.message || '获取每日统计数据失败');
      return rejectWithValue(error.message || '获取每日统计数据失败');
    }
  }
);

// 异步Action: 按时间段获取统计数据
export const fetchPeriodStatistics = createAsyncThunk(
  'statistics/fetchPeriodStatistics',
  async (params, { rejectWithValue }) => {
    try {
      const response = await statisticsApi.getStatisticsByPeriodType(params);
      return response.data;
    } catch (error) {
      message.error(error.message || '获取时间段统计数据失败');
      return rejectWithValue(error.message || '获取时间段统计数据失败');
    }
  }
);

// 异步Action: 获取最近交易记录
export const fetchRecentTransactions = createAsyncThunk(
  'statistics/fetchRecentTransactions',
  async (params, { rejectWithValue }) => {
    try {
      const response = await statisticsApi.getRecentTransactions(params);
      return response.data;
    } catch (error) {
      message.error(error.message || '获取最近交易记录失败');
      return rejectWithValue(error.message || '获取最近交易记录失败');
    }
  }
);

// 创建Slice
const statisticsSlice = createSlice({
  name: 'statistics',
  initialState,
  reducers: {
    // 重置统计数据状态
    resetStatistics: (state) => {
      return initialState;
    }
  },
  extraReducers: (builder) => {
    // 处理获取平台概览数据
    builder
      .addCase(fetchPlatformOverview.pending, (state) => {
        state.platformOverview.loading = true;
        state.platformOverview.error = null;
      })
      .addCase(fetchPlatformOverview.fulfilled, (state, action) => {
        state.platformOverview.loading = false;
        state.platformOverview.data = action.payload;
      })
      .addCase(fetchPlatformOverview.rejected, (state, action) => {
        state.platformOverview.loading = false;
        state.platformOverview.error = action.payload;
      })
      
      // 处理获取每日统计数据
      .addCase(fetchDailyStatistics.pending, (state) => {
        state.dailyStatistics.loading = true;
        state.dailyStatistics.error = null;
      })
      .addCase(fetchDailyStatistics.fulfilled, (state, action) => {
        state.dailyStatistics.loading = false;
        state.dailyStatistics.data = action.payload;
      })
      .addCase(fetchDailyStatistics.rejected, (state, action) => {
        state.dailyStatistics.loading = false;
        state.dailyStatistics.error = action.payload;
      })
      
      // 处理按时间段获取统计数据
      .addCase(fetchPeriodStatistics.pending, (state) => {
        state.periodStatistics.loading = true;
        state.periodStatistics.error = null;
      })
      .addCase(fetchPeriodStatistics.fulfilled, (state, action) => {
        state.periodStatistics.loading = false;
        console.log("action.payload", action.payload);
        state.periodStatistics.data = action.payload;
      })
      .addCase(fetchPeriodStatistics.rejected, (state, action) => {
        state.periodStatistics.loading = false;
        state.periodStatistics.error = action.payload;
      })
      
      // 处理获取最近交易记录
      .addCase(fetchRecentTransactions.pending, (state) => {
        state.recentTransactions.loading = true;
        state.recentTransactions.error = null;
      })
      .addCase(fetchRecentTransactions.fulfilled, (state, action) => {
        state.recentTransactions.loading = false;
       
        state.recentTransactions.data = action.payload;
      })
      .addCase(fetchRecentTransactions.rejected, (state, action) => {
        state.recentTransactions.loading = false;
        state.recentTransactions.error = action.payload;
      });
  }
});

// 导出Actions
export const { resetStatistics } = statisticsSlice.actions;

// 导出Selectors
export const selectPlatformOverview = (state) => state.statistics.platformOverview;
export const selectDailyStatistics = (state) => state.statistics.dailyStatistics;
export const selectPeriodStatistics = (state) => state.statistics.periodStatistics;
export const selectRecentTransactions = (state) => state.statistics.recentTransactions;

// 导出Reducer
export default statisticsSlice.reducer; 